import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, OnDestroy {

  languagesItems: MenuItem[] = []
  featuresList: any[] = [
    {
      iconName: "quraan.svg",
      titleAr: "تعلم القرآن الكريم",
      titleEn: "Learning the Holy Quran",
      descriptionAr: "تحسين التلاوة والفهم.",
      descriptionEn: "Improving recitation and understanding"
    },
    {
      iconName: "quran-listen.svg",
      titleAr: "استماع وقراءة القرآن الكريم",
      titleEn: "Listening to and reading the Holy Quran",
      descriptionAr: "بصوت أشهر القُرّاء.",
      descriptionEn: "In the voice of renowned reciters"
    },
    {
      iconName: "quraan-search.svg",
      titleAr: "بحث قرآني",
      titleEn: "Quranic Search",
      descriptionAr: "تسهيل الوصول إلى الآيات والسور وربطها بمواضيع بحثية",
      descriptionEn: "Easy access to verses and surahs, linking them to research topics"
    },
    {
      iconName: "child-section.svg",
      titleAr: "قسم للأطفال",
      titleEn: "Children's Section",
      descriptionAr: "تعلم الصلاة والوضوء.",
      descriptionEn: "Learning prayer and ablution"
    },
    {
      iconName: "podcast.svg",
      titleAr: "إذاعة هداية",
      titleEn: "Hidaya Radio",
      descriptionAr: "راديو على مدار الساعة بمحتوى حصري.",
      descriptionEn: "A round-the-clock radio with exclusive content."
    },
    {
      iconName: "adeya.svg",
      titleAr: "أدعية وأذكار وأناشيد",
      titleEn: "Supplications, Remembrances, and Nasheeds",
      descriptionAr: "لجميع المناسبات.",
      descriptionEn: "For all occasions"
    },
    {
      iconName: "prayer-times.svg",
      titleAr: "مواقيت الصلاة",
      titleEn: "Prayer Times",
      descriptionAr: "تنبيه بصوت المؤذن مع كل صلاة.",
      descriptionEn: "Call to prayer notification for each prayer"
    },
    {
      iconName: "hijri-calendar.svg",
      titleAr: "تقويم هجري",
      titleEn: "Hijri Calendar",
      descriptionAr: "لمتابعة ومعرفة المناسبات الإسلامية.",
      descriptionEn: "For tracking and knowing Islamic events"
    },
    {
      iconName: "qebla.svg",
      titleAr: "القبلة",
      titleEn: "Qibla",
      descriptionAr: "تحديد دقيق لاتجاه القبلة أينما كنت.",
      descriptionEn: "Accurate Qibla direction wherever you are"
    },
    {
      iconName: "near-mosques.svg",
      titleAr: "المساجد القريبة منك",
      titleEn: "Nearby Mosques",
      descriptionAr: "خريطة ذكية للوصول إلى أقرب مسجد.",
      descriptionEn: "Smart map to reach the nearest mosque"
    },
    {
      iconName: "reels.svg",
      titleAr: "الريلز",
      titleEn: "Reels",
      descriptionAr: "فيديوهات إسلامية متنوعة.",
      descriptionEn: "Diverse Islamic videos"
    },
    {
      iconName: "shazam.svg",
      titleAr: "شازام هداية",
      titleEn: "Hidaya Shazam",
      descriptionAr: "بحث صوتي داخل القرآن.",
      descriptionEn: "Voice search within the Quran"
    }
  ]

  allPackages = {
    libyana: [
      {
        id: "ae483690-905c-11ef-831b-6572c93a15e0",
        nameAr: "ليبيانا اليومية",
        nameEn: "Daily libyana",
        price: "500",
        currency: "PRICE_CURRENCY2"
      },
      {
        id: "b87f5b10-905c-11ef-a5af-d1f39c817705",
        nameAr: "ليبيانا الأسبوعية",
        nameEn: "Weekly libyana",
        price: "2.50",
        currency: "PRICE_CURRENCY"
      }
    ],
    elmadar: [
      {
        id: "d029ad50-905c-11ef-a87a-1bbfb56871ea",
        nameAr: "المدار الأسبوعية",
        nameEn: "Weekly Almadar",
        price: "2.50",
        currency: "PRICE_CURRENCY"
      }
    ]
  }

  images: any[] = [
    {
      image: '../../../assets/images/slider-1.png', alt: 'Image 1',
    },
    {
      image: '../../../assets/images/slider-2.png', alt: 'Image 2'
    },
    {
      image: '../../../assets/images/slider-3.png', alt: 'Image 3'
    },
    {
      image: '../../../assets/images/slider-4.png', alt: 'Image 4'
    },
    {
      image: '../../../assets/images/slider-5.png', alt: 'Image 5'
    },
    {
      image: '../../../assets/images/slider-6.png', alt: 'Image 6'
    },
  ];

  isCollapsed1: boolean = true
  isCollapsed2: boolean = true
  isCollapsed3: boolean = true
  isCollapsed4: boolean = true

  currentSlide: number = 0;
  slideInterval: any

  customOptions = {
    loop: true,
    margin: 0,
    autoplay: true,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  }

  constructor(public translate: TranslateService) { }

  ngOnInit() {
    // this.startAutoSlide();
  }

  ngOnDestroy(): void {
    if (this.slideInterval) {
      // clearInterval(this.slideInterval);
    }
  }

  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "autoplay": true,
    "autoplaySpeed": 2000
  };

  startAutoSlide(): void {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 3000);
  }

  prevSlide(): void {
    this.currentSlide = (this.currentSlide === 0) ? this.images.length - 1 : this.currentSlide - 1;
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide === this.images.length - 1) ? 0 : this.currentSlide + 1;
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }

}
